import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link, useHistory } from 'react-router-dom';
import { Icon, Loader, Modal } from 'semantic-ui-react';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  background-color:#fff;
  border:none;
  cursor:pointer;
`;
const ActualContent = styled.div`
  padding: 0 35px;
`;
const Header = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #4d4e4d;
  border-bottom: 1px solid #E5E5EA;
  padding: 0px 35px 16px 35px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  margin-top: 45px;
  justify-content: flex-end;
  border-top: 1px solid #E5E5EA;
  padding-top:24px;
`;

const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 127px;
  height: 47px;
  cursor:pointer;
`;
const Children = styled.div`
margin-top:24px;
`;
const ConfirmButton = styled.button`
  background: #444;
  border: 1px solid #444;
  border-radius: 5px;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  width: 127px;
  height: 47px;
  cursor:pointer;
  margin-right:35px;
`;
interface Props {
  onConfirmAction: () => void;
  buttonText: string;
  header: string;
  info?: string;
  cancelButtonText?: string;
  open: boolean;
  onClose: any;
  children?: any;
  height?: any;
  width?: any;
}

const ConfirmModal = (props: Props) => {
  const [loading, setLoading] = useState(false);
  return (
    <Modal open={props.open} style={{ height:props.height ? props.height : 390, width: props.width ? props.width : 496, zIndex: 500 }} onClose={props.onClose}>
      <ModalContent>
        <Close onClick={props.onClose}>
          <Icon name="close" />
        </Close>
          <Header>{props.header}?</Header>
          <ActualContent>
          <Children>{props.children && props.children}</Children>
          </ActualContent>
          <ButtonContainer>
            <CancelButton onClick={props.onClose}>{props.cancelButtonText || 'Cancel'}</CancelButton>
            <ConfirmButton onClick={props.onConfirmAction}>
              {loading ? (
                <Loader style={{ margin: '0 auto' }} size="mini" inline="centered" />
              ) : (
                props.buttonText
              )}
            </ConfirmButton>
          </ButtonContainer>

      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
